module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.1-230.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.1.md
// module id = 672
// module chunks = 310